/** True when the bill has saved sub-party breakdown entries (controls column + reference table). */
export function hasSubPartyBreakdown(billData) {
  const list = Array.isArray(billData?.subPartyBreakdown) ? billData.subPartyBreakdown : [];
  return list.length > 0;
}
